export default __webpack_public_path__ + "static/jandurasme-5ee56d2e0829a7b0d0236af9dd4c338c.png";